import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
export const ClearFilterButton = ({ onClick }) => {
    const { t } = useTranslation();
    // ToDo: Do we need the DIV wrapper?
    return _jsx("div", { children: _jsxs("button", { className: 'btn btn-link btn-sm', onClick: onClick, "data-testid": 'clear-filter-button', children: [_jsx(Icon, { name: 'times', className: 'mr-2' }), t('clearFilter')] }) });
};
